import { AsyncPipe, KeyValuePipe, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CommonContactSupportAdvisorModule } from '@capital-access/common/components';
import { CommonFeatureToggleModule } from '@capital-access/common/feature-toggle';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { FireflyDrawerModule, FireflySkeletonDrawerLoaderModule } from '@capital-access/firefly/components';
import { ContactSupportDrawerEffects } from './+state/contact-support-drawer.effects';
import { ContactSupportComponent } from './contact-support.component';
import { ContactSupportDrawer } from './contact-support-drawer';
import { DisclaimerComponent } from './disclaimer.component';

@NgModule({
  imports: [
    AsyncPipe,
    KeyValuePipe,
    NgFor,
    NgIf,
    CommonLocalizationModule,
    FireflyDrawerModule,
    EffectsModule.forFeature([ContactSupportDrawerEffects]),
    FireflySkeletonDrawerLoaderModule,
    CommonFeatureToggleModule,
    CommonContactSupportAdvisorModule
  ],
  declarations: [ContactSupportComponent, DisclaimerComponent],
  exports: [ContactSupportComponent],
  providers: [ContactSupportDrawer]
})
export class ContactSupportModule {}
